var map = {
	"./img/aging/favicon.ico": 445,
	"./img/aging/footer-logo.png": 446,
	"./img/aging/header-img.png": 447,
	"./img/aging/header-logo.png": 448,
	"./img/genes/favicon.ico": 449,
	"./img/genes/footer-logo.png": 450,
	"./img/genes/header-img.png": 451,
	"./img/genes/header-logo.png": 452,
	"./img/icons/aging/arrow-down.png": 453,
	"./img/icons/aging/arrow-right-dark.png": 454,
	"./img/icons/aging/arrow-right.png": 455,
	"./img/icons/aging/home.png": 456,
	"./img/icons/aging/ic_peer_review.png": 457,
	"./img/icons/aging/ic_plagerism.png": 458,
	"./img/icons/aging/ic_style_guidelines.png": 459,
	"./img/icons/aging/ic_submit.png": 460,
	"./img/icons/arrow-down-large.png": 461,
	"./img/icons/arrow-right.png": 462,
	"./img/icons/arrow-up-large.png": 463,
	"./img/icons/genes/arrow-down.png": 464,
	"./img/icons/genes/arrow-right-dark.png": 465,
	"./img/icons/genes/arrow-right.png": 466,
	"./img/icons/genes/home.png": 467,
	"./img/icons/genes/ic_peer_review.png": 468,
	"./img/icons/genes/ic_plagerism.png": 469,
	"./img/icons/genes/ic_style_guidelines.png": 470,
	"./img/icons/genes/ic_submit.png": 471,
	"./img/icons/oncoscience/arrow-down.png": 472,
	"./img/icons/oncoscience/arrow-right-dark.png": 473,
	"./img/icons/oncoscience/arrow-right.png": 474,
	"./img/icons/oncoscience/home.png": 475,
	"./img/icons/oncoscience/ic_peer_review.png": 476,
	"./img/icons/oncoscience/ic_plagerism.png": 477,
	"./img/icons/oncoscience/ic_style_guidelines.png": 478,
	"./img/icons/oncoscience/ic_submit.png": 479,
	"./img/icons/oncotarget/arrow-down.png": 480,
	"./img/icons/oncotarget/arrow-right-dark.png": 481,
	"./img/icons/oncotarget/arrow-right.png": 482,
	"./img/icons/oncotarget/home.png": 483,
	"./img/icons/oncotarget/ic_peer_review.png": 484,
	"./img/icons/oncotarget/ic_plagerism.png": 485,
	"./img/icons/oncotarget/ic_style_guidelines.png": 486,
	"./img/icons/oncotarget/ic_submit.png": 487,
	"./img/icons/search.png": 488,
	"./img/icons/social-fb.png": 489,
	"./img/icons/social-gp.png": 490,
	"./img/icons/social-li.png": 491,
	"./img/icons/social-tw.png": 492,
	"./img/icons/social-yt.png": 493,
	"./img/oncoscience/favicon.ico": 494,
	"./img/oncoscience/footer-logo.png": 166,
	"./img/oncoscience/header-img.png": 167,
	"./img/oncoscience/header-logo.png": 168,
	"./img/oncotarget/favicon.ico": 495,
	"./img/oncotarget/footer-logo.png": 496,
	"./img/oncotarget/header-img.png": 497,
	"./img/oncotarget/header-logo.png": 498,
	"./img/pause-circle.png": 499,
	"./img/play-circle.png": 500,
	"./img/rapamycin-logo.png": 501,
	"./img/share-circle.png": 502,
	"./img/temp/CurrentIssueCover.png": 503,
	"./img/temp/IssueCover.png": 504,
	"./img/temp/MobileSiteCover.png": 505,
	"./img/temp/SponsorshipCover.png": 506,
	"./img/temp/no-image-available.png": 507,
	"./img/temp/slide-1.jpg": 508,
	"./img/temp/slide-2.jpg": 509,
	"./img/temp/slide-3.jpg": 510,
	"./img/temp/slide-4.jpg": 511,
	"./img/temp/test_video.png": 512,
	"./mocks/article": 184,
	"./mocks/article-list": 183,
	"./mocks/article-list.json": 183,
	"./mocks/article-list_mock.png": 28,
	"./mocks/article.json": 184,
	"./mocks/article_mock.png": 29,
	"./mocks/issue": 185,
	"./mocks/issue.json": 185,
	"./mocks/issue_mock.png": 30,
	"./mocks/mock": 186,
	"./mocks/mock.json": 186,
	"./mocks/mock.png": 31,
	"./mocks/video-list": 187,
	"./mocks/video-list.json": 187,
	"./scss/_base.scss": 338,
	"./scss/_buttons.scss": 339,
	"./scss/_common.scss": 340,
	"./scss/_global-variables.scss": 341,
	"./scss/_helpers.scss": 342,
	"./scss/_icons.scss": 343,
	"./scss/_mixins.scss": 344,
	"./scss/site-themes/aging.scss": 345,
	"./scss/site-themes/genes.scss": 346,
	"./scss/site-themes/oncoscience.scss": 347,
	"./scss/site-themes/oncotarget.scss": 348,
	"./scss/site.scss": 27
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 182;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 182
// module chunks = 1